<template>
    <div class="form-container">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
            <!-- 活动标题 -->
            <el-form-item label="活动标题" prop="name">
                <el-input v-model="form.name" placeholder="请输入活动标题" maxlength="10" show-word-limit></el-input>
                
            </el-form-item>
            <!-- 活动价格 -->
            <el-form-item label="活动价格" prop="price">
                <!-- <el-input v-model.number="form.price" placeholder="请输入活动价格" type="number" min="0"
                          onkeypress="return(/[\d.]/.test(String.fromCharCode(event.keyCode)))">
                    <template slot="append">元</template>
                </el-input> -->
                <NumberInput v-model="form.price" :placeholder="'请输入活动价格'" number-only :size="'medium'" />元
            </el-form-item>
            <el-form-item label="活动背景图片配置" prop="share_back" class="is-required" >
                <el-col :span="24">
                    <activityCustomUpload :tip="'温馨提示：建议宽度为750*1480px；大小限制在500kb之内'" :formName="'share_back'" :formValue="form.share_back" @uploadSuccess="uploadSuccess">
                    </activityCustomUpload>
                </el-col>
            </el-form-item>
            <el-form-item label="活动海报图配置" prop="poster_url" class="is-required">
                <el-col :span="24">
                    <activityCustomUpload :tip="'温馨提示：建议宽度为594*434px，限制200kb以内'" :formName="'poster_url'" :formValue="form.poster_url" @uploadSuccess="uploadSuccess">
                    </activityCustomUpload>
                </el-col>
            </el-form-item>
            <el-form-item label="赠品配置">
                <el-button type="primary" size="mini" @click="opencourseHandel" >赠品管理</el-button>
            </el-form-item>
            <!-- 提交按钮 -->
            <el-form-item>
                <el-button type="primary" @click="submitForm">立即提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import {createUpdate ,getInfo} from "@/api/luminaryplan";
import NumberInput from "@/components/number_input.vue";
export default {
    data() {
        return {
            form: {
                name: "",
                price: null,
                share_back:'',
                poster_url:'',
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入活动标题",
                        trigger: "blur",
                    },
                    {
                        min: 2,
                        max: 20,
                        message: "长度在 2 到 20 个字符",
                        trigger: "blur",
                    },
                ],
                price: [
                    {
                        required: true,
                        message: "请输入活动价格",
                        trigger: "blur",
                    },
                ],
                share_back: [
                    {
                        required: true,
                        message: "请上传活动背景图片配置",
                        trigger: "change",
                    },  
                ],
                poster_url: [
                    {
                        required: true,
                        message: "请上传活动海报图配置",
                        trigger: "change",
                    }, 
                ]
            },
        };
    },
    components: {
        activityCustomUpload,
        NumberInput
    },
    mounted() {
        this.getpageInfo();
    },
    methods: {
      opencourseHandel(){
        /*window.open("http://admin.defen.hzxinquanzi.com/?c=course&m=setOrderPresent&item_type=11&target_id=410&object_id=0&p=31", "_blank");*/
        if (window.location.host == 'dev.backend.zhangdefenspace.com') {
          window.open("http://dev.admin.defen.hzxinquanzi.com/?c=course&m=setOrderPresent&item_type=11&target_id=410&object_id=0&p=31", "_blank");
        } else {
          window.open("http://admin.defen.hzxinquanzi.com/?c=course&m=setOrderPresent&item_type=11&target_id=410&object_id=0&p=31", "_blank");
          // window.open(`http://dev.admin.defen.hzxinquanzi.com/?c=course&m=course_list&p=31&title=${id}`);
        }
      },
        submitForm() {
            this.$refs.formRef.validate((valid) => {
              console.log(this.form);
                if (valid) {
                  
                  if(this.form.poster_url == ''){
                    this.$message({
                      message: '请上传活动海报图配置',
                      type: "error",
                    });
                    return false;
                    }
                    if(this.form.share_back == ''){
                    this.$message({
                      message: '请上传活动背景图片配置',
                      type: "error", 
                    }) 
                    }
                    // 这里添加提交逻辑
                    createUpdate(this.form).then(res=>{
                      if(res.code == 1){
                        this.$message({
                          message: '保存成功',
                          type: "success",
                        }); 
                      }
                    })
                    // console.log("保存成功", this.form);
                    // this.$axios.post('/api/submit', this.form).then(res => {...})
                } else {
                    console.log("请填写******后再保存");
                    return false;
                }
            });
        },
        uploadSuccess(value) {
            const fileExtension = value.fileUrl.split(".").pop().toLowerCase();

            // 判断是否是图片格式
            const isImageFormat = ["png", "jpeg", "jpg", "gif", ""].includes(
                fileExtension
            );

            if (isImageFormat) {
                // console.log('是图片格式');
                this.form[value.formName] = this.rules[value.formName] =
                    value.fileUrl;
                this.$refs.formRef.validateField(value.formName);
            } else {
                this.$message({
                    message: "请上传图片格式文件",
                    type: "error",
                });
                return;
            }
        },
        getpageInfo() {
            getInfo().then(res => {
                if(res.code == 1){
                    this.form = res.data;
                    this.form.price = Number(this.form.price);
                    console.log(res.data);
                    
                } 
            })
        },
    },
};
</script>

<style >
.form-container {
    padding: 20px;
    max-width: 600px;
}
.form-container .el-form-item__label{
  width: 136px !important;
}
.form-container .el-form-item__content {
    margin-left: 140px !important;
}
</style>
